"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/jsx-props-no-spreading */
function componentHasChild(component, child) {
  var property = Object.values(component).find(function (val) {
    return child.type === val;
  });
  return !!property;
}

var UppercaseText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "BreadCrumbs__UppercaseText",
  componentId: "sc-9mp74w-0"
})(["text-transform:uppercase;"]);
var ClickableFlex = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "BreadCrumbs__ClickableFlex",
  componentId: "sc-9mp74w-1"
})(["cursor:pointer;"]);

var BreadCrumb = function BreadCrumb(_ref) {
  var BreadCrumbsContext = _ref.context,
      icon = _ref.icon,
      text = _ref.text,
      mr = _ref.mr,
      fontSize = _ref.fontSize,
      inactiveColor = _ref.inactiveColor,
      activeColor = _ref.activeColor,
      textProps = _ref.textProps,
      iconProps = _ref.iconProps,
      isClickable = _ref.isClickable;

  var _useContext = (0, _react.useContext)(BreadCrumbsContext),
      activeCrumb = _useContext.activeCrumb,
      setActiveCrumb = _useContext.setActiveCrumb;

  var isActive = activeCrumb === text;
  var ContainerFlex = isClickable ? ClickableFlex : _Flex["default"];
  var handleClick = isClickable ? function () {
    return setActiveCrumb(text);
  } : null;
  return /*#__PURE__*/_react["default"].createElement(ContainerFlex, {
    width: "auto",
    alignItems: "center",
    mx: 1,
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(UppercaseText, (0, _extends2["default"])({
    mr: mr,
    fontSize: fontSize,
    color: isActive ? activeColor : inactiveColor
  }, textProps), text), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    name: icon,
    p: 2,
    borderRadius: 99,
    color: "dark.2"
  }, iconProps)));
};

BreadCrumb.propTypes = {
  icon: _propTypes["default"].string,
  mr: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  fontSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  inactiveColor: _propTypes["default"].string,
  activeColor: _propTypes["default"].string
};
BreadCrumb.defaultProps = {
  icon: "chevron_right",
  mr: 6,
  fontSize: 3,
  inactiveColor: "dark.2",
  activeColor: "primary.0"
};

var BreadCrumbs = function BreadCrumbs(_ref2) {
  var BreadCrumbsContext = _ref2.context,
      children = _ref2.children,
      py = _ref2.py,
      bg = _ref2.bg,
      mb = _ref2.mb;
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    py: py,
    width: 1 / 1,
    bg: bg,
    justifyContent: "center",
    mb: mb
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: 9 / 10,
    justifyContent: "space-around",
    alignItems: "center"
  }, _react["default"].Children.map(children, function (child) {
    if (componentHasChild(BreadCrumbs, child)) {
      return /*#__PURE__*/_react["default"].cloneElement(child, {
        context: BreadCrumbsContext
      });
    }

    return child;
  })));
};

BreadCrumbs.Crumb = BreadCrumb;
BreadCrumbs.propTypes = {
  context: _propTypes["default"].shape({
    $$typeof: _propTypes["default"].symbol
  }).isRequired,
  bg: _propTypes["default"].string,
  py: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  mb: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array])
};
BreadCrumbs.defaultProps = {
  bg: "secondary.2",
  py: 3,
  mb: 4
};
var _default = BreadCrumbs;
exports["default"] = _default;